module.exports = {"singular":"Kontingent","plural":"Kontingente","amount":"Menge","tickets":"Tickets"};